import * as types from "../ActionType";

const initState = {
    creativeWork: [],
    loadingcreativeWork: true
}

const CreativeWorkReducer = (state = initState, action) => {
    switch (action.type) {
        case types.GET_CREATIVE_WORK:
            return { ...state, creativeWork: action.payload, loadingcreativeWork: false }
        default:
            return state;
    }
};

export default CreativeWorkReducer;
